/* DSL Cart suggestions — toon related-product op basis van laatste cart-toevoeging */
(function(){
  document.addEventListener("dsl:cart:add", function(e){
    var pid = e.detail && e.detail.product_id;
    if (!pid) return;
    fetch("/recommendations/products.json?product_id=" + pid + "&limit=3&intent=related")
      .then(function(r){return r.json();})
      .then(function(data){
        var slot = document.querySelector("[data-cart-suggestions]");
        if (!slot || !data.products) return;
        slot.innerHTML = "<h3>Past goed hierbij</h3>" + data.products.map(function(p){
          return "<a href=\"" + p.url + "\" class=\"dsl-cart-sug__card\"><img src=\"" + p.featured_image + "&width=160\" width=\"160\" height=\"160\" alt=\"\" loading=\"lazy\"><span>" + p.title + "</span></a>";
        }).join("");
      }).catch(function(){});
  });
})();